import { setAuthorization } from '../helpers/api/apiCore';
import { authApiResponseSuccess } from '../redux/actions';
import { AuthActionTypes } from '../redux/auth/constants';

export const handleUserLogin = (dispatch, api, user) => {
    // Set the logged-in user
    api.setLoggedInUser(user);

    // Set authorization token
    setAuthorization(user['token']);

    // Dispatch the success action for the login
    dispatch(authApiResponseSuccess(AuthActionTypes.LOGIN_USER, user));
};

export const sizePerPageList = [
    {
        text: '5',
        value: 5,
    },
    {
        text: '10',
        value: 10,
    },
    {
        text: '25',
        value: 25,
    },
    {
        text: '50',
        value: 50,
    },
];

export const masterColumns = (t) => [
    { Header: t('Device ID'), accessor: 'device_id', sort: true },
    { Header: t('Asset Type Name'), accessor: 'asset_type_name', sort: true },
    { Header: t('Asset Type Code'), accessor: 'asset_type_code', sort: true },
    { Header: t('Asset Type Id'), accessor: 'asset_type_id', sort: true },
    { Header: t('Asset Number Code'), accessor: 'asset_number_code', sort: true },
    { Header: t('Asset Number ID'), accessor: 'asset_number_id', sort: true },

    { Header: t('SMMS Code'), accessor: 'smms_asset_code', sort: true },
    { Header: t('SMMS Name'), accessor: 'smms_asset_name', sort: true },

    { Header: t('Vendor Name'), accessor: 'vendor_name', sort: true },
    { Header: t('Channel'), accessor: 'channel', sort: false },
    { Header: t('Type'), accessor: 'type', sort: true },
];

export const addStationColumns = (t) => [
    {
        Header: t('Created Date'),
        accessor: 'createdDate',
        sort: true,
    },
    {
        Header: t('Zone Name'),
        accessor: 'zoneName',
        sort: true,
    },
    {
        Header: t('Zone Code'),
        accessor: 'zoneCode',
        sort: true,
    },
    {
        Header: t('Division Name'),
        accessor: 'divisionName',
        sort: true,
    },
    {
        Header: t('Division Code'),
        accessor: 'divisionCode',
        sort: true,
    },
    {
        Header: t('Station Name'),
        accessor: 'stationName',
        sort: true,
    },
    {
        Header: t('Station Code'),
        accessor: 'stationCode',
        sort: true,
    },
    {
        Header: t('Station Master Name'),
        accessor: 'stationMasterName',
        sort: false,
    },
    {
        Header: t('City'),
        accessor: 'city',
        sort: false,
    },
    {
        Header: t('State'),
        accessor: 'state',
        sort: false,
    },
    {
        Header: t('Hardware'),
        accessor: 'hardware',
        sort: false,
    },
    {
        Header: t('Software'),
        accessor: 'software',
        sort: false,
    },
    {
        Header: t('Action'),
        accessor: 'action',
        sort: false,
    },
];
export const addZoneColumns = (t) => [
    {
        Header: t('Created Date'),
        accessor: 'createdDate', // FIXED
    },
    {
        Header: t('Zone Name'),
        accessor: 'zoneName', // FIXED
    },
    {
        Header: t('Zone Code'),
        accessor: 'zoneCode', // FIXED
    },
    {
        Header: t('Zone ID'),
        accessor: 'zoneId', // FIXED
    },

    {
        Header: t('Action'),
        accessor: 'action',
    },
];

export const addDivisionColumns = (t) => [
    {
        Header: t('Created Date'),
        accessor: 'createdDate',
        sort: true,
    },
    {
        Header: t('Zone ID'),
        accessor: 'zoneId',
        sort: true,
    },
    {
        Header: t('Zone Code'),
        accessor: 'zoneCode',
        sort: true,
    },
    {
        Header: t('Zone Name'),
        accessor: 'zoneName',
        sort: true,
    },
    {
        Header: t('Division Name'),
        accessor: 'divisionName',
        sort: true,
    },
    {
        Header: t('Division Code'),
        accessor: 'divisionCode',
        sort: true,
    },
    {
        Header: t('Division ID'),
        accessor: 'divisionId',
        sort: true,
    },

    {
        Header: t('Action'),
        accessor: 'action',
    },
];
export const addVendorColumns = (t) => [
    {
        Header: t('Created Date'),
        accessor: 'createdAt',
    },
    {
        Header: t('Cloud Code'),
        accessor: 'vendor_cloud_code',
    },
    {
        Header: t('Cloud Name'),
        accessor: 'vendor_cloud_name',
    },
    {
        Header: t('Gateway Code'),
        accessor: 'vendor_gw_code',
    },
    {
        Header: t('Gateway Name'),
        accessor: 'vendor_gw_name',
    },

    {
        Header: t('Action'),
        accessor: 'action',
    },
];
export const addUserColumns = (t) => [
    {
        Header: t('Created Date'),
        accessor: 'createdAt',
    },
    {
        Header: t('Name'),
        accessor: 'name',
    },
    {
        Header: t('Email'),
        accessor: 'email',
    },
    {
        Header: t('Role'),
        accessor: 'role',
    },
    {
        Header: t('Location'),
        accessor: 'location',
    },
    {
        Header: t('User ID'),
        accessor: 'userId',
    },
    {
        Header: t('Action'),
        accessor: 'action',
    },
];

export const addDCCircuitColumns = (t) => [
    { Header: t('Created Date'), accessor: 'createdDate', sort: true },
    { Header: t('Track Number'), accessor: 'trackNumber', sort: true },
    { Header: t('Parameter Type Id'), accessor: 'parameterTypeId', sort: true },
    { Header: t('Type Code'), accessor: 'assetTypeCode', sort: true },
    { Header: t('Number Code'), accessor: 'assetNumberCode', sort: true },
    { Header: t('SMMS Code'), accessor: 'smmsAssetCode', sort: true },
    { Header: t('SMMS Name'), accessor: 'smmsAssetName', sort: true },
    { Header: t('Device ID'), accessor: 'device', sort: true },
    { Header: t('Channel'), accessor: 'channel', sort: false },
    { Header: t('Type'), accessor: 'type', sort: true },
    { Header: t('Station Master Name'), accessor: 'stationMasterName', sort: false },
    { Header: t('Station'), accessor: 'stationName', sort: false },
    { Header: t('Vendor'), accessor: 'vendor', sort: true },
    { Header: t('City'), accessor: 'city', sort: false },
    { Header: t('State'), accessor: 'state', sort: false },
    { Header: t('Alert'), accessor: 'stopAlert', sort: false },
    { Header: t('Action'), accessor: 'action', sort: false },
];

export const addPointMachineColumns = (t) => [
    { Header: t('Created Date'), accessor: 'createdDate', sort: true },
    { Header: t('Point Machine'), accessor: 'pointMachine', sort: true },
    { Header: t('Parameter Type Id'), accessor: 'parameterTypeId', sort: true },
    { Header: t('Type Code'), accessor: 'assetTypeCode', sort: true },
    { Header: t('Number Code'), accessor: 'assetNumberCode', sort: true },
    { Header: t('SMMS Code'), accessor: 'smmsAssetCode', sort: true },
    { Header: t('SMMS Name'), accessor: 'smmsAssetName', sort: true },
    { Header: t('Device ID'), accessor: 'device', sort: true },
    { Header: t('Channel'), accessor: 'channel', sort: false },
    { Header: t('Type'), accessor: 'type', sort: true },
    { Header: t('Station Master Name'), accessor: 'stationMasterName', sort: false },
    { Header: t('Station'), accessor: 'stationName', sort: false },
    { Header: t('Vendor'), accessor: 'vendor', sort: true },
    { Header: t('City'), accessor: 'city', sort: false },
    { Header: t('State'), accessor: 'state', sort: false },
    { Header: t('Alert'), accessor: 'stopAlert', sort: false },
    { Header: t('Action'), accessor: 'action', sort: false },
];

export const addBatteriesColumns = (t) => [
    { Header: t('Created Date'), accessor: 'createdDate', sort: true },
    { Header: t('Battery Charger'), accessor: 'batteryCharger', sort: true },
    { Header: t('Parameter Type Id'), accessor: 'parameterTypeId', sort: true },
    { Header: t('Type Code'), accessor: 'assetTypeCode', sort: true },
    { Header: t('Number Code'), accessor: 'assetNumberCode', sort: true },
    { Header: t('SMMS Code'), accessor: 'smmsAssetCode', sort: true },
    { Header: t('SMMS Name'), accessor: 'smmsAssetName', sort: true },
    { Header: t('Device ID'), accessor: 'device', sort: true },
    { Header: t('Channel'), accessor: 'channel', sort: false },
    { Header: t('Type'), accessor: 'type', sort: true },
    { Header: t('Station Master Name'), accessor: 'stationMasterName', sort: false },
    { Header: t('Station'), accessor: 'stationName', sort: false },
    { Header: t('Vendor'), accessor: 'vendor', sort: true },
    { Header: t('City'), accessor: 'city', sort: false },
    { Header: t('State'), accessor: 'state', sort: false },
    { Header: t('Alert'), accessor: 'stopAlert', sort: false },
    { Header: t('Action'), accessor: 'action', sort: false },
];

export const addSignalColumns = (t) => [
    { Header: t('Created Date'), accessor: 'createdDate', sort: true },
    { Header: t('Signal Number'), accessor: 'signalNumber', sort: true },
    { Header: t('Parameter Type Id'), accessor: 'parameterTypeId', sort: true },
    { Header: t('Type Code'), accessor: 'assetTypeCode', sort: true },
    { Header: t('Number Code'), accessor: 'assetNumberCode', sort: true },
    { Header: t('SMMS Code'), accessor: 'smmsAssetCode', sort: true },
    { Header: t('SMMS Name'), accessor: 'smmsAssetName', sort: true },
    { Header: t('Device ID'), accessor: 'device', sort: true },
    { Header: t('Channel'), accessor: 'channel', sort: false },
    { Header: t('Type'), accessor: 'type', sort: true },
    { Header: t('Station Master Name'), accessor: 'stationMasterName', sort: false },
    { Header: t('Station'), accessor: 'stationName', sort: false },
    { Header: t('Vendor'), accessor: 'vendor', sort: true },
    { Header: t('City'), accessor: 'city', sort: false },
    { Header: t('State'), accessor: 'state', sort: false },
    {
        Header: () => <div style={{ color: '#ff0000' }}>{t('Red Bulb')}</div>,
        accessor: 'redBulb',
        sort: false,
    },
    {
        Header: () => <div style={{ color: '#34cb4a' }}>{t('Green Bulb')}</div>,
        accessor: 'greenBulb',
        sort: false,
    },
    {
        Header: () => <div style={{ color: '#fdbe40' }}>{t('Yellow Bulb')}</div>,
        accessor: 'yellowBulb',
        sort: false,
    },
    {
        Header: () => <div style={{ color: '#fdbe40' }}>{t('Other Bulb')}</div>,
        accessor: 'otherBulb',
        sort: false,
    },
    { Header: t('Alert'), accessor: 'stopAlert', sort: false },
    { Header: t('Action'), accessor: 'action', sort: false },
];

export const addIPSColumns = (t) => [
    { Header: t('Created Date'), accessor: 'createdDate', sort: true },
    { Header: t('IPS'), accessor: 'ips', sort: true },
    { Header: t('Parameter Type Id'), accessor: 'parameterTypeId', sort: true },
    { Header: t('Type Code'), accessor: 'assetTypeCode', sort: true },
    { Header: t('Number Code'), accessor: 'assetNumberCode', sort: true },
    { Header: t('SMMS Code'), accessor: 'smmsAssetCode', sort: true },
    { Header: t('SMMS Name'), accessor: 'smmsAssetName', sort: true },
    { Header: t('Device ID'), accessor: 'device', sort: true },
    { Header: t('Channel'), accessor: 'channel', sort: false },
    { Header: t('Type'), accessor: 'type', sort: true },
    { Header: t('Station Master Name'), accessor: 'stationMasterName', sort: false },
    { Header: t('Station'), accessor: 'stationName', sort: false },
    { Header: t('Vendor'), accessor: 'vendor', sort: true },
    { Header: t('City'), accessor: 'city', sort: false },
    { Header: t('State'), accessor: 'state', sort: false },
    { Header: t('Alert'), accessor: 'stopAlert', sort: false },
    { Header: t('Action'), accessor: 'action', sort: false },
];

export const addHassdacColumns = (t) => [
    { Header: t('Created Date'), accessor: 'createdDate', sort: true },
    { Header: t('Hassdac'), accessor: 'hassdac', sort: true },
    { Header: t('Parameter Type Id'), accessor: 'parameterTypeId', sort: true },
    { Header: t('Type Code'), accessor: 'assetTypeCode', sort: true },
    { Header: t('Number Code'), accessor: 'assetNumberCode', sort: true },
    { Header: t('SMMS Code'), accessor: 'smmsAssetCode', sort: true },
    { Header: t('SMMS Name'), accessor: 'smmsAssetName', sort: true },
    { Header: t('Device ID'), accessor: 'device', sort: true },
    { Header: t('Channel'), accessor: 'channel', sort: false },
    { Header: t('Type'), accessor: 'type', sort: true },
    { Header: t('Station Master Name'), accessor: 'stationMasterName', sort: false },
    { Header: t('Station'), accessor: 'stationName', sort: false },
    { Header: t('Vendor'), accessor: 'vendor', sort: true },
    { Header: t('City'), accessor: 'city', sort: false },
    { Header: t('State'), accessor: 'state', sort: false },
    { Header: t('Alert'), accessor: 'stopAlert', sort: false },
    { Header: t('Action'), accessor: 'action', sort: false },
];

export const dcCircuitColumns = (t) => [
    {
        Header: t('Time Stamp'),
        accessor: 'timeStamp',
        sort: true,
    },
    {
        Header: t('DC Circuit'),
        accessor: 'trackNumber',
        sort: true,
    },
    {
        Header: t('Feed End Voltage'),
        accessor: 'feedEndVoltage',
        sort: false,
    },
    {
        Header: t('Relay End Voltage'),
        accessor: 'relayEndVoltage',
        sort: false,
    },
    {
        Header: t('Charger Current'),
        accessor: 'chargerCurrent',
        sort: false,
    },
    {
        Header: t('Relay End Current'),
        accessor: 'relayEndCurrent',
        sort: false,
    },
    {
        Header: t('Feed End Current'),
        accessor: 'feedEndCurrent',
        sort: false,
    },
    {
        Header: t('TPR Status'),
        accessor: 'tprStatus',
        sort: false,
    },
    {
        Header: t('Charger Potential Free Contact'),
        accessor: 'chargerPotentialFreeContact',
        sort: false,
    },
    {
        Header: t('View'),
        accessor: 'view',
        sort: false,
    },
];
export const dcCircuitMainColumns = (t) => [
    {
        Header: t('Time Stamp'),
        accessor: 'timeStamp',
        sort: true,
    },
    {
        Header: t('Feed End Voltage'),
        accessor: 'feedEndVoltage',
        sort: false,
    },
    {
        Header: t('Relay End Voltage'),
        accessor: 'relayEndVoltage',
        sort: false,
    },

    {
        Header: t('Charger Current'),
        accessor: 'chargerCurrent',
        sort: false,
    },
    {
        Header: t('TPR Status'),
        accessor: 'tprStatus',
        sort: false,
    },
    {
        Header: t('Charger Potential Free Contact'),
        accessor: 'chargerPotentialFreeContact',
        sort: false,
    },
    {
        Header: t('Relay End Current'),
        accessor: 'relayEndCurrent',
        sort: false,
    },
    {
        Header: t('Feed End Current'),
        accessor: 'feedEndCurrent',
        sort: false,
    },
    {
        Header: t('View'),
        accessor: 'view',
        sort: false,
    },
];

export const hassdacColumns = (t) => [
    {
        Header: t('Time Stamp'),
        accessor: 'timeStamp',
        sort: true,
    },
    {
        Header: t('HASSDAC'),
        accessor: 'hassdac',
        sort: true,
    },
    {
        Header: t('Input Voltage'),
        accessor: 'inputVoltage',
        sort: false,
    },
    {
        Header: t('Input Current'),
        accessor: 'inputCurrent',
        sort: false,
    },
    {
        Header: t('Vital Relay Voltage'),
        accessor: 'vitalRelayVoltage',
        sort: false,
    },
    {
        Header: t('Vital Relay Current'),
        accessor: 'vitalRelayCurrent',
        sort: false,
    },
    {
        Header: t(' Reset Voltage'),
        accessor: 'resetVoltage',
        sort: false,
    },

    {
        Header: t('View'),
        accessor: 'view',
        sort: false,
    },
];
export const hassdacMainColumns = (t) => [
    {
        Header: t('Time Stamp'),
        accessor: 'timeStamp',
        sort: true,
    },
    {
        Header: t('Input Voltage'),
        accessor: 'inputVoltage',
        sort: false,
    },
    {
        Header: t('Input Current'),
        accessor: 'inputCurrent',
        sort: false,
    },
    {
        Header: t('Vital Relay Voltage'),
        accessor: 'vitalRelayVoltage',
        sort: false,
    },
    {
        Header: t('Vital Relay Current'),
        accessor: 'vitalRelayCurrent',
        sort: false,
    },
    {
        Header: t(' Reset Voltage'),
        accessor: 'resetVoltage',
        sort: false,
    },

    {
        Header: t('View'),
        accessor: 'view',
        sort: false,
    },
];

export const pointMachineColumns = (t) => [
    {
        Header: t('Time Stamp'),
        accessor: 'timeStamp',
        sort: true,
    },
    {
        Header: t('Point Machine'),
        accessor: 'pointMachine',
        sort: true,
    },
    {
        Header: t('Normal Operating Current'),
        accessor: 'forwardOperatingCurrent',
        sort: true,
    },
    {
        Header: t('Reverse Operating Current'),
        accessor: 'reverseOperatingCurrent',
        sort: true,
    },
    {
        Header: t('Normal Operating Voltage'),
        accessor: 'forwardOperatingVoltage',
        sort: false,
    },
    {
        Header: t('Reverse Operating Voltage'),
        accessor: 'reverseOperatingVoltage',
        sort: false,
    },
    // {
    //     Header: t('Time of Operation'),
    //     accessor: 'timeOfOperation',
    //     sort: true,
    // },
    {
        Header: t('Point Position Voltage'),
        accessor: 'pointPositionVoltage',
        sort: false,
    },
    // {
    //     Header: t('Vibration'),
    //     accessor: 'vibration',
    //     sort: true,
    // },
    {
        Header: t('Point Position Relay'),
        accessor: 'pointPositionRelay',
        sort: false,
    },
    {
        Header: t('View'),
        accessor: 'view',
        sort: false,
    },
];
export const pointMachineMainColumns = (t) => [
    {
        Header: t('Time Stamp'),
        accessor: 'timeStamp',
        sort: true,
    },
    {
        Header: t('Normal Operating Current'),
        accessor: 'forwardOperatingCurrent',
        sort: true,
    },
    {
        Header: t('Reverse Operating Current'),
        accessor: 'reverseOperatingCurrent',
        sort: true,
    },
    {
        Header: t('Normal Operating Voltage'),
        accessor: 'forwardOperatingVoltage',
        sort: false,
    },
    {
        Header: t('Reverse Operating Voltage'),
        accessor: 'reverseOperatingVoltage',
        sort: false,
    },
    // {
    //     Header: t('Time of Operation'),
    //     accessor: 'timeOfOperation',
    //     sort: true,
    // },
    {
        Header: t('Point Position Voltage'),
        accessor: 'pointPositionVoltage',
        sort: false,
    },
    {
        Header: t('Point Position Relay'),
        accessor: 'pointPositionRelay',
        sort: false,
    },
    {
        Header: t('Vibration'),
        accessor: 'vibration',
        sort: true,
    },
    {
        Header: t('View'),
        accessor: 'view',
        sort: false,
    },
];

export const batteriesColumns = (t) => [
    {
        Header: t('Time Stamp'),
        accessor: 'timeStamp',
        sort: true,
    },
    {
        Header: t('Battery Charger'),
        accessor: 'batteryCharger',
        sort: true,
    },
    {
        Header: t('Charger Input Voltage'),
        accessor: 'chargerInputVoltage',
        sort: false,
    },
    {
        Header: t('Charger Input Current'),
        accessor: 'chargerInputCurrent',
        sort: false,
    },
    {
        Header: t('Charger Output Voltage'),
        accessor: 'chargerOutputVoltage',
        sort: false,
    },
    {
        Header: t('Charger Output Current'),
        accessor: 'chargerOutputCurrent',
        sort: false,
    },
    {
        Header: t('Combined Voltage'),
        accessor: 'batteryOutputVoltage',
        sort: false,
    },
    {
        Header: t('Combined Current'),
        accessor: 'batteryOutputCurrent',
        sort: false,
    },
    {
        Header: t('View'),
        accessor: 'view',
        sort: false,
    },
];
export const batteriesMainColumns = (t) => [
    {
        Header: t('Time Stamp'),
        accessor: 'timeStamp',
        sort: true,
    },
    {
        Header: t('Charger Input Voltage'),
        accessor: 'chargerInputVoltage',
        sort: false,
    },
    {
        Header: t('Charger Input Current'),
        accessor: 'chargerInputCurrent',
        sort: false,
    },
    {
        Header: t('Charger Output Voltage'),
        accessor: 'chargerOutputVoltage',
        sort: false,
    },
    {
        Header: t('Charger Output Current'),
        accessor: 'chargerOutputCurrent',
        sort: false,
    },
    {
        Header: t('Combined Voltage'),
        accessor: 'batteryOutputVoltage',
        sort: false,
    },
    {
        Header: t('Combined Current'),
        accessor: 'batteryOutputCurrent',
        sort: false,
    },
    {
        Header: t('View'),
        accessor: 'view',
        sort: false,
    },
];

export const SignalColumns = (t) => [
    {
        Header: t('Time Stamp'),
        accessor: 'timeStamp',
        sort: true,
    },
    {
        Header: t('Signal Number'),
        accessor: 'signalNumber',
        sort: true,
    },
    {
        Header: () => (
            <div
                style={{
                    color: '#ff0000',
                }}>
                {t('AC Voltage')}
            </div>
        ),
        accessor: 'redAcVoltage',
        sort: false,
    },
    {
        Header: () => (
            <div
                style={{
                    color: '#ff0000',
                }}>
                {t('AC Current')}
            </div>
        ),
        accessor: 'redAcCurrent',
        sort: false,
    },
    {
        Header: () => (
            <div
                style={{
                    color: '#34cb4a',
                }}>
                {t('AC Voltage')}
            </div>
        ),
        accessor: 'greenAcVoltage',
        sort: false,
    },

    {
        Header: () => (
            <div
                style={{
                    color: '#34cb4a',
                }}>
                {t('AC Current')}
            </div>
        ),
        accessor: 'greenAcCurrent',
        sort: false,
    },
    {
        Header: () => (
            <div
                style={{
                    color: '#F4D03F',
                }}>
                {t('AC Voltage')}
            </div>
        ),
        accessor: 'yellowAcVoltage',
        sort: false,
    },
    {
        Header: () => (
            <div
                style={{
                    color: '#F4D03F',
                }}>
                {t('AC Current')}
            </div>
        ),
        accessor: 'yellowAcCurrent',
        sort: false,
    },
    {
        Header: () => (
            <div
                style={{
                    color: '#F39C12',
                }}>
                {t('AC Voltage')}
            </div>
        ),
        accessor: 'otherAcVoltage',
        sort: false,
    },
    {
        Header: () => (
            <div
                style={{
                    color: '#F39C12',
                }}>
                {t('AC Current')}
            </div>
        ),
        accessor: 'otherAcCurrent',
        sort: false,
    },
    {
        Header: t('Status'),
        accessor: 'status',
        sort: false,
    },
    {
        Header: t('View'),
        accessor: 'view',
        sort: false,
    },
];
export const SignalMainColumns = (t) => [
    {
        Header: t('Time Stamp'),
        accessor: 'timeStamp',
        sort: true,
    },
    {
        Header: t('Signal Number'),
        accessor: 'signalNumber',
        sort: true,
    },
    {
        Header: () => (
            <div
                style={{
                    color: '#ff0000',
                }}>
                {t('AC Voltage')}
            </div>
        ),
        accessor: 'redAcVoltage',
        sort: false,
    },
    {
        Header: () => (
            <div
                style={{
                    color: '#ff0000',
                }}>
                {t('AC Current')}
            </div>
        ),
        accessor: 'redAcCurrent',
        sort: false,
    },
    {
        Header: () => (
            <div
                style={{
                    color: '#34cb4a',
                }}>
                {t('AC Voltage')}
            </div>
        ),
        accessor: 'greenAcVoltage',
        sort: false,
    },

    {
        Header: () => (
            <div
                style={{
                    color: '#34cb4a',
                }}>
                {t('AC Current')}
            </div>
        ),
        accessor: 'greenAcCurrent',
        sort: false,
    },
    {
        Header: () => (
            <div
                style={{
                    color: '#F4D03F',
                }}>
                {t('AC Voltage')}
            </div>
        ),
        accessor: 'yellowAcVoltage',
        sort: false,
    },
    {
        Header: () => (
            <div
                style={{
                    color: '#F4D03F',
                }}>
                {t('AC Current')}
            </div>
        ),
        accessor: 'yellowAcCurrent',
        sort: false,
    },
    {
        Header: () => (
            <div
                style={{
                    color: '#F39C12',
                }}>
                {t('AC Voltage')}
            </div>
        ),
        accessor: 'otherAcVoltage',
        sort: false,
    },
    {
        Header: () => (
            <div
                style={{
                    color: '#F39C12',
                }}>
                {t('AC Current')}
            </div>
        ),
        accessor: 'otherAcCurrent',
        sort: false,
    },
    {
        Header: t('Status'),
        accessor: 'status',
        sort: false,
    },
    {
        Header: t('View'),
        accessor: 'view',
        sort: false,
    },
];

export const IPSColumns = (t) => [
    {
        Header: t('Time Stamp'),
        accessor: 'timeStamp',
        sort: true,
    },
    {
        Header: t('IPS'),
        accessor: 'ips',
        sort: true,
    },
    {
        id: '1',
        Header: () => (
            <div
                style={{
                    textAlign: 'center',
                }}>
                {t('Input')}
            </div>
        ),
        columns: [
            {
                Header: t('Voltage'),
                accessor: 'inputVoltage',
            },
            {
                Header: t('Current'),
                accessor: 'inputCurrent',
            },
        ],
    },
    {
        Header: t('FRBC Output Voltage'),
        accessor: 'frbcOutputVoltage',
        sort: false,
    },
    {
        id: '2',
        Header: () => (
            <div
                style={{
                    textAlign: 'center',
                }}>
                {t('Battery')}
            </div>
        ),
        columns: [
            {
                Header: t('Output Voltage'),
                accessor: 'batteryOutputVoltage',
            },
            {
                Header: t('Charging Current'),
                accessor: 'batteryChargingCurrent',
            },
        ],
    },
    {
        id: '3',
        Header: () => (
            <div
                style={{
                    textAlign: 'center',
                }}>
                {t('DC-DC-Converter')}
            </div>
        ),
        columns: [
            {
                Header: t('Output Current'),
                accessor: 'dcConverterOutputCurrent',
            },
            {
                Header: t('Output Voltage'),
                accessor: 'dcConverterOutputVoltage',
            },
        ],
    },
    {
        id: '4',
        Header: () => (
            <div
                style={{
                    textAlign: 'center',
                }}>
                {t('Inverter')}
            </div>
        ),
        columns: [
            {
                Header: t('Input Voltage'),
                accessor: 'inverterInputVoltage',
            },
            {
                Header: t('Output Voltage'),
                accessor: 'inverterOutputVoltage',
            },
            {
                Header: t('Output Current'),
                accessor: 'inverterOutputCurrent',
            },
        ],
    },

    {
        Header: t('Health of IPS modules through PFC'),
        accessor: 'healthOfIPSModulesThroughPFC',
        sort: false,
    },
    {
        Header: t('Availability of standby Power Supply'),
        accessor: 'availabilityOfStandbyPowerSupply',
        sort: false,
    },
    {
        Header: t('View'),
        accessor: 'view',
        sort: false,
    },
];
export const IPSMainColumns = (t) => [
    {
        Header: t('Time Stamp'),
        accessor: 'timeStamp',
        sort: true,
    },
    {
        Header: t('Input Voltage'),
        accessor: 'inputVoltage',
        sort: false,
    },
    {
        Header: t('Input Current'),
        accessor: 'inputCurrent',
        sort: false,
    },
    {
        Header: t('FRBC Output Voltage'),
        accessor: 'frbcOutputVoltage',
        sort: false,
    },
    {
        Header: t('DC 24 Voltage'),
        accessor: 'batteryOutputVoltage',
        sort: false,
    },
    {
        Header: t('DC Current (24V Channel)'),
        accessor: 'batteryChargingCurrent',
        sort: false,
    },
    {
        Header: t('DC Output Current'),
        accessor: 'dcConverterOutputCurrent',
        sort: false,
    },
    {
        Header: t('DC Output Voltage'),
        accessor: 'dcConverterOutputVoltage',
        sort: false,
    },
    {
        Header: t('Inverter Input Voltage'),
        accessor: 'inverterInputVoltage',
        sort: false,
    },
    {
        Header: t('AC 110 Voltage'),
        accessor: 'inverterOutputVoltage',
        sort: false,
    },
    {
        Header: t('AC Current 110v'),
        accessor: 'inverterOutputCurrent',
        sort: false,
    },
    {
        Header: t('Health of IPS modules through PFC'),
        accessor: 'healthOfIPSModulesThroughPFC',
        sort: false,
    },
    {
        Header: t('Availability of standby Power Supply'),
        accessor: 'availabilityOfStandbyPowerSupply',
        sort: false,
    },
    {
        Header: t('View'),
        accessor: 'view',
        sort: false,
    },
];

export const addRelayColumns = (t) => [
    { Header: t('Created Date'), accessor: 'createdDate', sort: true },
    { Header: t('Relay'), accessor: 'relay', sort: true },
    { Header: t('Parameter Type Id'), accessor: 'parameterTypeId', sort: true },
    { Header: t('Type Code'), accessor: 'assetTypeCode', sort: true },
    { Header: t('Number Code'), accessor: 'assetNumberCode', sort: true },
    { Header: t('SMMS Code'), accessor: 'smmsAssetCode', sort: true },
    { Header: t('SMMS Name'), accessor: 'smmsAssetName', sort: true },
    { Header: t('Device ID'), accessor: 'device', sort: true },
    { Header: t('Channel'), accessor: 'channel', sort: false },
    { Header: t('Type'), accessor: 'type', sort: true },
    { Header: t('Station Master Name'), accessor: 'stationMasterName', sort: false },
    { Header: t('Station'), accessor: 'stationName', sort: false },
    { Header: t('Vendor'), accessor: 'vendor', sort: true },
    { Header: t('City'), accessor: 'city', sort: false },
    { Header: t('State'), accessor: 'state', sort: false },
    { Header: t('Alert'), accessor: 'stopAlert', sort: false },
    { Header: t('Action'), accessor: 'action', sort: false },
];

export const relayColumns = (t) => [
    {
        Header: t('Time Stamp'),
        accessor: 'timeStamp',
        sort: true,
    },
    {
        Header: t('Relay'),
        accessor: 'relay',
        sort: true,
    },
    {
        Header: t('Relay Voltage'),
        accessor: 'relayVoltage',
        sort: false,
    },
    {
        Header: t('Relay Current'),
        accessor: 'relayCurrent',
        sort: false,
    },
    {
        Header: t('Power Supply Voltage'),
        accessor: 'powerSupplyVoltage',
        sort: false,
    },
    {
        Header: t('Power Supply Current'),
        accessor: 'powerSupplyCurrent',
        sort: false,
    },
    {
        Header: t('View'),
        accessor: 'view',
        sort: false,
    },
];

export const relayMainColumns = (t) => [
    {
        Header: t('Time Stamp'),
        accessor: 'timeStamp',
        sort: true,
    },
    {
        Header: t('Relay'),
        accessor: 'relay',
        sort: true,
    },
    {
        Header: t('Relay Voltage'),
        accessor: 'relayVoltage',
        sort: false,
    },
    {
        Header: t('Relay Current'),
        accessor: 'relayCurrent',
        sort: false,
    },
    {
        Header: t('Power Supply Voltage'),
        accessor: 'powerSupplyVoltage',
        sort: false,
    },
    {
        Header: t('Power Supply Current'),
        accessor: 'powerSupplyCurrent',
        sort: false,
    },
    {
        Header: t('View'),
        accessor: 'view',
        sort: false,
    },
];
